/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createPaymentCurrencyRepository = (options: RestApiOptions): Types.PaymentCurrencyRepository => ({
    async get(params, requestOptions) {
        return options.request('/paymentCurrency/get', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
